export default "__VITE_ASSET__5$NKj_dzayPOCo2iZEjLvw__"